import { render, staticRenderFns } from "./authorizat.vue?vue&type=template&id=c2d55cb6&scoped=true&"
import script from "./authorizat.vue?vue&type=script&lang=js&"
export * from "./authorizat.vue?vue&type=script&lang=js&"
import style0 from "./authorizat.vue?vue&type=style&index=0&id=c2d55cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d55cb6",
  null
  
)

export default component.exports